export const ASSIGN_ALERTS_TO_USER = 'ASSIGN_ALERTS_TO_USER';
export const ASSIGN_ALERTS_TO_USER_SUCCESS = 'ASSIGN_ALERTS_TO_USER_SUCCESS';
export const ASSIGN_ALERTS_TO_USER_FAIL = 'ASSIGN_ALERTS_TO_USER_FAIL';
export const ALERT_ACTION_INFO_MODAL_CLOSE = 'ALERT_ACTION_INFO_MODAL_CLOSE';
export const ASSIGN_ALERTS_TO_USER_RESET = 'ASSIGN_ALERTS_TO_USER_RESET';

export const assignAlertsToUser = ({ alertIds, user }) => ({
  type: ASSIGN_ALERTS_TO_USER,
  payload: { alertIds, user }
});

export const assignAlertsToUserSuccess = () => ({
  type: ASSIGN_ALERTS_TO_USER_SUCCESS
});

export const assignAlertsToUserFail = (message) => ({
  type: ASSIGN_ALERTS_TO_USER_FAIL,
  payload: { message }
});

export const alertActionInfoModalClose = () => ({
  type: ALERT_ACTION_INFO_MODAL_CLOSE
});

export const assignAlertsToUserRest = () => ({
  type: ASSIGN_ALERTS_TO_USER_RESET
});
